module.exports = __webpack_public_path__ + "img/zhendong-1.png";